import { UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import CogIcon from '../../../assets/icons/cog.svg';
import { openBookingSettings as openBookingSettingsAction } from '../../../Bookings';
import { TranslateProp } from '../../../common-types';
import Theme from '../../../theme';
import StudioWorkoutStartingHeaderButton from './StudioWorkoutStartingHeaderButton';

interface IParentProps {
  workout: UserWorkoutSession;
  userProfile: UserProfile;
  t: TranslateProp;
}

interface IDispatchProps {
  openBookingSettings: () => void;
}

const WorkoutSettingsButton: FunctionComponent<IParentProps & IDispatchProps> = (
  {
    t,
    openBookingSettings,
  },
) => (
  <StudioWorkoutStartingHeaderButton
    Icon={CogIcon}
    iconColor={Theme.PRIMARY}
    text={t('StartingStudioWorkoutSettingsButton')}
    subText={t('StartingStudioWorkoutSettingsButtonSubTile')}
    rightButton
    onPress={openBookingSettings}
  />
);

const mapDispatchToProps = (dispatch, ownProps: IParentProps): IDispatchProps => ({
  openBookingSettings: () => dispatch(openBookingSettingsAction(ownProps.userProfile, ownProps.workout)),
});

export default connect(null, mapDispatchToProps)(WorkoutSettingsButton);
